import { API_ROLE_LIST, API_ROLE_DELETE, API_ROLE_DETAIL, API_ROLE_SAVE } from '@/common/constants';
import { get, post, del, put } from '@/utils/http';

export const getRoleList = (currentPage = 1, pageSize = 10, keyWord) => {
    return get(API_ROLE_LIST, { currentPage, pageSize, roleName: keyWord });
};

export const getRoleDetail = (roleId) => {
    return get(API_ROLE_DETAIL.replace(':roleId', roleId));
};

export const delRole = (roleId) => {
    return del(API_ROLE_DELETE.replace(':roleId', roleId));
};

export const saveRole = (role) => {
    if(role.id==undefined||role.id==''){
        return post(API_ROLE_SAVE, role);
    }else{
        return put(API_ROLE_SAVE, role);
    }       
};

export const updRole = (role) => {
    return put(API_ROLE_SAVE, role);
};
// Role ROLE role



// WEBPACK FOOTER //
// ./src/data-model/system/role-model.js